import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Contents.css";

export default function StudyMaterial() {
  const navigate = useNavigate();

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">

      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Study Material</h1>
        <p>
          Carefully designed learning resources for Classes 8, 9 & 10,
          covering both CBSE and State syllabus to support strong academic performance.
        </p>
      </section>

      {/* MATERIAL TYPES */}
      <section className="mission-section">
        <h2 className="reveal-left">📚 Learning Resources</h2>

        {/* ✅ IMPORTANT: reveal wrapper */}
        <div className="mission-grid reveal">

          {/* NOTES */}
          <div
            className="mission-card clickable-card"
            onClick={() => navigate("/material/notes")}
          >
            <h3>📘 Notes</h3>
            <p>
              Clear, structured and exam-oriented notes designed to
              build strong conceptual understanding.
            </p>
            <ul style={{ marginTop: "12px", color: "#475569", fontSize: "14px" }}>
              <li>✔ Class 8, 9 & 10 coverage</li>
              <li>✔ CBSE & State syllabus aligned</li>
              <li>✔ Key formulas & summaries</li>
            </ul>
            <span className="click-hint">Explore Notes →</span>
          </div>

          {/* PREVIOUS PAPERS */}
          <div
            className="mission-card clickable-card"
            onClick={() => navigate("/material/papers")}
          >
            <h3>📝 Previous Year Papers</h3>
            <p>
              Practice with real exam-level questions to understand
              patterns, difficulty level and marking schemes.
            </p>
            <ul style={{ marginTop: "12px", color: "#475569", fontSize: "14px" }}>
              <li>✔ Board & school exam papers</li>
              <li>✔ Class-wise segregation</li>
              <li>✔ Helps in exam confidence</li>
            </ul>
            <span className="click-hint">View Papers →</span>
          </div>

          {/* DPPs */}
          <div
            className="mission-card clickable-card"
            onClick={() => navigate("/material/dpps")}
          >
            <h3>📅 Daily Practice Problems (DPPs)</h3>
            <p>
              Regular practice sets to improve speed, accuracy and
              application of concepts.
            </p>
            <ul style={{ marginTop: "12px", color: "#475569", fontSize: "14px" }}>
              <li>✔ Topic-wise daily questions</li>
              <li>✔ Increasing difficulty level</li>
              <li>✔ Ideal for exam preparation</li>
            </ul>
            <span className="click-hint">Start Practice →</span>
          </div>

        </div>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          Our study materials are continuously updated based on syllabus
          changes and exam trends, ensuring students stay ahead and confident.
        </p>
      </section>

    </div>
  );
}
